import React from 'react'

import mouse from './../../UI/animation/Icon_Mouse.svg'
import mouse_spart from './../../UI/animation/Icon_Mouse_Spark.svg'

import GETWebParams from '../../helpers/GETWebParams';
const params = GETWebParams()

interface Props {
  openScene: boolean,
  showCollapse: boolean
}

interface State {
  showCollapseMenu: boolean
  firstTimeShowed: boolean
}

class Collapse extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      showCollapseMenu: false,
      firstTimeShowed: true
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    /*if(prevProps.openScene !== this.props.openScene && !this.props.openScene){
      this.setState({
        firstTimeShowed: true //si se desea que se muestre con cada auto
      })
    }

    /*if(prevProps.showCollapse !== this.props.showCollapse){
    if(prevProps.showCollapse !== this.props.showCollapse){
      if(this.state.firstTimeShowed && this.props.showCollapse){
        setTimeout(() => {
          this.setState({
            showCollapseMenu: true,
            firstTimeShowed: false
          })
        }, 1000)
      }
      if (!this.props.showCollapse){
        this.setState({
          showCollapseMenu: false
        })
      }
    }*/
    if(prevProps.openScene !== this.props.openScene && this.props.openScene){
      setTimeout(() => {
        this.setState({
          showCollapseMenu: true,
        })
      }, 1000)
    }

    if (prevProps.showCollapse !== this.props.showCollapse){
      this.setState({
        showCollapseMenu: false
      })
    }
  }
  
  render(): React.ReactNode {
      return(
        <div className={`collapse-animation-container${params.lite !== "true" ? '' : ' lite '} ${(this.state.showCollapseMenu) ? 'fade-in':'fade-out'}`}>
          <div className='collapse-animation-container-main'>
            <div className='collapse-animation-icon-container'>
              <img src={mouse_spart} alt='' className='collapse-icon-animation'/>
              <img src={mouse} alt='' className='collapse-icon'/>
            </div>
            <div className='collapse-animation-text'>
              <div className='collapse-animation-text-reduced'>
                Haz clic para mostrar las configuraciones
              </div>
            </div>
          </div>
        </div>
      )
  }
}

export default Collapse